
export default function AboutStory() {
  return (
    <section className="py-16 md:py-24 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="space-y-6 md:space-y-8">
            <div className="space-y-3 md:space-y-4">
              <p className="text-xs font-semibold tracking-widest text-[#D4AF37] uppercase">
                Who We Are
              </p>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2A2A2A] leading-tight">
                Builders of{' '}
                <span className="font-serif text-[#D4AF37]">Refined Spaces</span>
              </h2>
            </div>
            <div className="space-y-4 md:space-y-5 text-sm md:text-base text-gray-600 leading-relaxed">
              <p>
                <strong>Tadashi Consulting</strong> was founded with a singular vision: to
                elevate the standard of{' '}
                <strong>renovation and construction</strong> in Johannesburg. We saw an
                industry where quality was often compromised, timelines were rarely met,
                and clients were left in the dark. We set out to change that.
              </p>
              <p>
                Today, we are one of Gauteng&apos;s most trusted{' '}
                <strong>luxury renovation</strong> firms, serving high-income homeowners,
                property investors, developers, and commercial property owners who
                demand excellence. Every project we undertake reflects our commitment to
                precision, transparency, and refined craftsmanship.
              </p>
              <p>
                From initial site inspection to final handover, our licensed contractors
                manage every phase of construction with full accountability. We don&apos;t
                subcontract quality — our in-house teams deliver the premium finishes and
                structural integrity that define the Tadashi standard.
              </p>
            </div>
          </div>
          <div className="relative">
            <div className="rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl">
              <div className="w-full h-[350px] sm:h-[450px] lg:h-[560px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/946dc1ccd64a85aa3203c8d9560e3f7a.jpg"
                  alt="Tadashi Consulting design consultation"
                  title="Luxury renovation consultation Johannesburg"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
